module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ru-097b629d57d4188b9b831cca54f5875e.svg";